import axiosInstance from "./AxiosInstance";
const auditUrl = "api/audit_circular";
// user
export function getAuditListApi(page, page_size, query,status) {
  const params = new URLSearchParams({
    page,
    page_size,
    query,
    status
  });
  return axiosInstance.get(`${auditUrl}?${params.toString()}`);
}

export function getAuditApi(id) {
  return axiosInstance.get(`${auditUrl}/${id}`);
}

export function createAuditApi(data) {
  return axiosInstance.post(auditUrl, data);
}

export function editAuditApi(data) {
  return axiosInstance.put(auditUrl, data);
}

export function updateAuditApi(data) {
  return axiosInstance.put(auditUrl, data);
}

export function updateAuditStatusApi(id, data) {
  return axiosInstance.patch(`api/audit_circular/${id}`, data);
}

export function createAuditReport(data) {
  return axiosInstance.post("api/audit_report", data);
}

export function getAuditReport(id) {
  return axiosInstance.get(`api/audit_report/${id}`);
}

export function updateReportStatusApi(id, data) {
  return axiosInstance.patch(`api/audit_report/${id}`, data);
}

export function getAuditorList(id) {
  return axiosInstance.get(`api/search_auditor/${id}`);
}


